module.exports = require(`./${process.env.REACT_APP_LANG || "GE-EN"}`);
